import React from 'react';
import { Link } from 'react-router-dom';
import './ContinueWatching.css';
import harryPotterImage from '../images/harrypotter.jpg';
import interstellarImage from '../images/interstellar.jpg';
import matrixImage from '../images/matrix.avif';
import ratatouilleImage from '../images/ratatouille.jpg';

type ProfileType = 'recruiter' | 'developer' | 'stalker';

interface ContinueWatchingProps {
  profile: ProfileType;
}

const continueWatchingConfig = {
  recruiter: [
    { title: "Blogs", imgSrc: ratatouilleImage, link: "/blogs" },
    { title: "Education", imgSrc: harryPotterImage, link: "/education" },
    { title: "Skills", imgSrc: matrixImage, link: "/skills" },
    { title: "Contact Me", imgSrc: interstellarImage, link: "/contact-me" }
  ],
  developer: [
    { title: "Blogs", imgSrc: ratatouilleImage, link: "/blogs" },
    { title: "Education", imgSrc: harryPotterImage, link: "/education" },
    { title: "Skills", imgSrc: matrixImage, link: "/skills" },
    { title: "Contact Me", imgSrc: interstellarImage, link: "/contact-me" }
  ],
  stalker: [
    { title: "Blogs", imgSrc: ratatouilleImage, link: "/blogs" },
    { title: "Education", imgSrc: harryPotterImage, link: "/education" },
    { title: "Skills", imgSrc: matrixImage, link: "/skills" },
    { title: "Contact Me", imgSrc: interstellarImage, link: "/contact-me" }
  ],
};

const ContinueWatching: React.FC<ContinueWatchingProps> = ({ profile }) => {
  const continueWatching = continueWatchingConfig[profile];

  return (
    <div className="continue-watching-row">
      <h2 className="row-title">Continue Watching for {profile.charAt(0).toUpperCase() + profile.slice(1)}</h2>
      <div className="card-row">
        {continueWatching.map((pick, index) => (
          <Link to={pick.link} key={index} className="pick-card">
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ContinueWatching;
